module.exports = __webpack_public_path__ + "img/thumb_12.acee2007.jpg";